export function splitByCapitalLetter(str: string): string {
  // Use regex to split the string by capital letters
  const words: string[] = str.split(/(?=[A-Z])/);

  return words.map((word: string) => word).join(" ");
}
